import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { EditNoteWrapper } from "@/portals/(shared)/(new-note)/components/EditNoteWrapper";
import { usePatientDetails } from "@/features/patient/api/queries/usePatientDetails";

import { CARE_MANAGEMENT_INITIAL_VALUES } from "./CareManagementForm.schema";
import { CareManagementForm } from "./CareManagementForm";

// this component is used when a new care management assessment is filled out
export const CareManagementNewNote = () => {
  const { patientId } = useParams();
  const { data: patient } = usePatientDetails({ patientId });

  const provider = useSelector((state) => state.auth.profile);
  const [initialValues, setInitialValues] = useState();

  // setup form state
  useEffect(() => {
    if (!patient || !provider) {
      return;
    }
    const noteStateToClone = CARE_MANAGEMENT_INITIAL_VALUES;
    const localInitialValues = cloneDeep(noteStateToClone);

    localInitialValues.patient_id = patient.username;
    localInitialValues.patient_first_name = patient.first_name;
    localInitialValues.patient_last_name = patient.last_name;

    localInitialValues.provider_id = provider.username;
    localInitialValues.provider_name = provider.name;
    localInitialValues.provider_type = provider.provider_type;
    localInitialValues.provider_cp_credentials = provider.cp_credentials;
    setInitialValues(localInitialValues);
  }, [patient, provider]);

  return (
    <EditNoteWrapper patientId={patientId}>
      <CareManagementForm
        isEditing={true}
        nameToSign={provider?.name}
        noteState={initialValues}
        patientId={patient?.username}
      />
    </EditNoteWrapper>
  );
};
